import { StateCreator } from "zustand";
import {
  ApolloClient,
  NormalizedCacheObject,
} from "@apollo/client";

export interface ICaseSlice {
  caseStatuses: {
    name: string;
    value: number;
    color?: string;
    search_name: string;
  }[];
  casePriorities: {
    name: string;
    value: number;
    color?: string;
    search_name: string;
  }[];
  caseTypes: {
    name: string;
    value: number;
    color?: string;
    search_name: string;
  }[];
}

const createCaseSlice: StateCreator<ICaseSlice, [], [], ICaseSlice> = (
  set,
  get
) => ({
  caseStatuses: [
    { name: "Resolved", value: 1, color: "#4caf50", search_name: "RESOLVED" },
    { name: "Open", value: 2, color: "#f44336", search_name: "OPEN" },
    { name: "In Progress", value: 3, color: "#2196f3", search_name: "IN_PROGRESS" },
    { name: "Waiting For Customer", value: 4, color: "#f44336", search_name: "WAITING_FOR_CUSTOMER" },
  ],
  casePriorities: [
    { name: "High", value: 1, color: "#f44336", search_name: "HIGH" },
    { name: "Medium", value: 2, color: "#ff9800", search_name: "MEDIUM" },
    { name: "Low", value: 3, color: "#4caf50", search_name: "LOW" },
  ],
  caseTypes: [
    { name: "Bug", value: 1, color: "#f44336", search_name: "BUG" },
    { name: "Feature Request", value: 2, color: "#2196f3", search_name: "FEATURE_REQUEST" },
  ],
});

export default createCaseSlice;
